import GettingStarted from "assets/Dashboard/icons/side-menu/gettin-started.svg";
import GettingStartedActive from "assets/Dashboard/icons/side-menu/gettin-started-active.svg";
import Activity from "assets/Dashboard/icons/side-menu/activity.svg";
import ActivityActive from "assets/Dashboard/icons/side-menu/activity-active.svg";
import Application from "assets/Dashboard/icons/side-menu/application.svg";
import ApplicationActive from "assets/Dashboard/icons/side-menu/application-active.svg";
import Settings from "assets/Dashboard/icons/side-menu/settings.svg";
import SettingsActive from "assets/Dashboard/icons/side-menu/settings-active.svg";
import ROUTE_PATH from "Routes/paths";

export const SIDE_MENU_CUSTOM_ACTIONS = {
  REFER: "refer action",
  EMAIL: "email action",
  SCHEME: "scheme action",
  RATE: "rate action",
  LOGOUT: "logout action",
  REST_MPIN: "reset-mpin action",
};

const sideMenuList = [
  {
    img: GettingStarted,
    activeImg: GettingStartedActive,
    text: "Getting Started",
    onClick: ROUTE_PATH.DASHBOARD.HOME,
  },
  {
    img: Activity,
    activeImg: ActivityActive,
    text: "Activity",
    onClick: ROUTE_PATH.DASHBOARD.ACTIVITY,
  },
  {
    img: Application,
    activeImg: ApplicationActive,
    text: "Application",
    onClick: ROUTE_PATH.DASHBOARD.APPLICATION,
  },
  // {
  //   img: Settings,
  //   activeImg: SettingsActive,
  //   text: "Settings",
  //   onClick: SIDE_MENU_CUSTOM_ACTIONS.EMAIL,
  // },
];
export default sideMenuList;
